import { render, staticRenderFns } from "./ProposalDetail.vue?vue&type=template&id=613062f5"
import script from "./ProposalDetail.vue?vue&type=script&lang=js"
export * from "./ProposalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports